import { useNavigate } from "react-router-dom";
import React, { useEffect, useState, useCallback } from "react";
// import { useAuth } from "../../app/useAuth";
import MainLayout from "../../components/layouts/main";

export default function N5Records() {
    // const auth = useAuth();
    const navigate = useNavigate();
    const [textSearch, setTextSearch] = useState("");
    const [submitSearch, setSubmitSearch] = useState(false);
    const [advancedSearch, setAdvancedSearch] = useState("all");
    const [advancedSearchText, setAdvancedSearchText] = useState("");

    const handleSubmitSearch = useCallback(() => {
        const checkAdvancedSearchObject = JSON.stringify(advancedSearchText) === JSON.stringify({});
        if (checkAdvancedSearchObject) {
            navigate(`/search/n7/${textSearch ? textSearch : advancedSearchText}`);
        } else {
            const urlParams = new URLSearchParams(advancedSearchText).toString();
            navigate(`/search/n7/advanced?${urlParams}`);
        }
        setSubmitSearch(false);
    }, [textSearch, navigate, advancedSearch, advancedSearchText]);

    useEffect(() => {
        if (submitSearch) {
            handleSubmitSearch();
        }
    }, [submitSearch, handleSubmitSearch]);

    const arrRules = [
        // {
        //     title: "Filter",
        //     value: "filter",
        // },
        {
            title: "Position",
            value: "position",
        },
        {
            title: "Chromosome No",
            value: "chromosome_no",
        },
    ];

    return (
        <MainLayout
            pathname="/search/n7"
            arrRules={arrRules}
            header="SNV Data"
            exampleText={
                <div>
                    Examples - SNV ID: <span className="text-primary">10113984060</span>, <span className="text-primary">10100002068</span>,{" "}
                    <span className="text-primary">vcZ240GZJ</span> Position: <span className="text-primary">1-2068</span>
                </div>
            }
            textSearch={textSearch}
            setTextSearch={setTextSearch}
            setSubmitSearch={setSubmitSearch}
            setAdvancedSearch={setAdvancedSearch}
            advancedSearchText={advancedSearchText}
            setAdvancedSearchText={setAdvancedSearchText}
        />
    );
}
